// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {buildPayload} from '../../shared/services/build-payload';
import {getPartReturns} from '../../shared/repositories';
import {readExcelLayouts} from '../../../shared/action-creators/read-excel-layouts';

export const readAllPartRequests = facets =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const allPartRequestsPayload = buildPayload(facets, '', '');

        try {

            const data = await getPartReturns(allPartRequestsPayload);

            dispatch({
                data,
                type: actions.READ_ALL_PART_REQUESTS_SUCCESS
            });

            if (!getState().exportToExcel.selectedExcelLayout.partRequests.name) {

                readExcelLayouts('partRequests')(dispatch);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/part-requests/all-parts-requests/action-creators/all-part-requests.js